module.exports = __webpack_public_path__ + "media/images/lp_consultation/reviews-voice03-55afd39ea7a8959ce3c77a96434342f0.jpg";